var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 310.245 106.448",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.232 21.128h-4.52v38.367a5.6 5.6 0 0 1-5.595 5.597H21.128v4.517h35.99a10.126 10.126 0 0 0 10.114-10.114zM239.276 33.67h-94.78a8.54 8.54 0 0 0-8.53 8.531v3.169a8.54 8.54 0 0 0 8.53 8.53h34.59a4.017 4.017 0 0 1 4.013 4.012v3.168a4.017 4.017 0 0 1-4.013 4.012h-94.78a4.017 4.017 0 0 1-4.013-4.012V42.201a4.017 4.017 0 0 1 4.012-4.012h34.588a4.017 4.017 0 0 1 4.013 4.012v7.18H88.79v4.518h38.634V42.201a8.646 8.646 0 0 0-8.532-8.53H84.305a8.54 8.54 0 0 0-8.53 8.53V61.08a8.54 8.54 0 0 0 8.53 8.53h94.78a8.54 8.54 0 0 0 8.53-8.53v-3.168a8.644 8.644 0 0 0-8.53-8.531h-34.59a4.015 4.015 0 0 1-4.01-4.011v-3.169a4.016 4.016 0 0 1 4.01-4.012h94.781a4.017 4.017 0 0 1 4.013 4.012V61.08a4.017 4.017 0 0 1-4.013 4.012l-43.12.003V85.32h4.52V69.609h38.6a8.54 8.54 0 0 0 8.53-8.53V42.202a8.644 8.644 0 0 0-8.53-8.531M256.347 42.201V69.61h4.519V42.2a4.016 4.016 0 0 1 4.01-4.012h24.241V33.67h-24.241a8.54 8.54 0 0 0-8.53 8.531"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.38867f2161a01a3095beda194a6b6f89.svg";
export { ForwardRef as ReactComponent };